import { type ReactNode, useEffect, useState } from 'react';

export const ClientOnly = ({ children }: { children: ReactNode }) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return !hasMounted ? null : <>{children}</>;
};
